export default __webpack_public_path__ + "static/media/imgLoja04.9a406ec6.png";